import { useDispatch, useSelector } from "react-redux";
import { useMemo } from "react";
import { addToHubspotHandler, addToSalesforceHandler, addToZohoHandler } from "@redux/Bookmark/bookmark.action";
import CloudDownload from "@assets/images/icons/cloud_download.svg";
import Contacts from "@assets/images/icons/contacts.svg";
import Delete from "@assets/images/icons/delete.svg";
import More from "@assets/images/icons/more.svg";
import Exit from "@assets/images/icons/exit_to_app.svg";
import { toast } from "react-toastify";
import { SelectionBarTemplete } from "@components/templates/SelectionBar/SelectionBar";
import { pendoEventType } from "@containers/CompanyBookmark/utils/constant";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import getTrackingEventDictionary from "@core/dictionary/tracking-event";
import { generateTrackingObject } from "@core/global/global-country-functions";

const addToSalesForce = {
  icon: Exit,
  name: "Export to SalesForce",
};

export const addToZoho = {
  icon: Exit,
  name: "Export to Zoho",
};

export const addToHubspot = {
  icon: Exit,
  name: "Export to Hubspot",
};

export const SelectionBar = ({ setShowContactModal, setShowFavModal, clearSelection, setShowDeleteModal, selectedCompanyArray, setDownloadModal, type }) => {
  const userDetails = useSelector((state) => state.userDetails);
  const STARTERPLAN = userDetails?.creditDetails?.data?.find((data) => data?.is_active && data?.user_active_plan?.toLowerCase()?.includes("starter"))?.navigate === "search";
  const dispatch = useDispatch();

  const selectionOptions = useMemo(() => {
    if (userDetails?.userData) {
      let mergedData = selectedCompanyArray.filter((item) => !!item.is_merged);
      let unMergedData = selectedCompanyArray.filter((item) => !item.is_merged);
      let selectionOptionsClone = [
        {
          icon: CloudDownload,
          name: "Download",
          cb: () => {
            setDownloadModal(true);
            trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "bulk_download", { ...generateTrackingObject(`intel-${type}-favourite`) });
          },
        },
        {
          icon: More,
          name: "Add Tags",
          cb: () => {
            setShowFavModal(true);
            trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "bulk_add_tags", { ...generateTrackingObject(`intel-${type}-favourite`) });
          },
        },
        {
          icon: Contacts,
          name: "Fetch Contacts",
          cb: () => {
            trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "bulk_fetch_contacts", { ...generateTrackingObject(`intel-${type}-favourite`) });
            if (mergedData.length > 0 && unMergedData.length === 0) {
              toast.error("Please select companies other than Merged companies to fetch contacts");
            } else {
              setShowContactModal(true);
            }
          },
        },
        {
          icon: Delete,
          name: "Remove",
          cb: () => {
            setShowDeleteModal(true);
            trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "bulk_delete", { ...generateTrackingObject(`intel-${type}-favourite`) });
          },
        },
      ];
      const { is_hubspot_active, is_salesforce_active, is_zoho_active } = userDetails.userData;
      if (is_hubspot_active && type !== "logistics") {
        selectionOptionsClone.splice(2, 0, {
          ...addToHubspot,
          cb: () => {
            trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "bulk_export_to_hubspot", { ...generateTrackingObject(`intel-${type}-favourite`) });
            dispatch(addToHubspotHandler({ selectedCompanyArray }));
          },
        });
      }
      if (is_salesforce_active && type !== "logistics") {
        selectionOptionsClone.splice(2, 0, {
          ...addToSalesForce,
          cb: () => {
            trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "bulk_export_to_salesforce", { ...generateTrackingObject(`intel-${type}-favourite`) });
            dispatch(addToSalesforceHandler({ selectedCompanyArray }));
          },
        });
      }
      if (is_zoho_active && type !== "logistics") {
        selectionOptionsClone.splice(2, 0, {
          ...addToZoho,
          cb: () => {
            trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "bulk_export_to_zoho", { ...generateTrackingObject(`intel-${type}-favourite`) });
            dispatch(addToZohoHandler({ selectedCompanyArray }));
          },
        });
      }
      if (STARTERPLAN) {
        selectionOptionsClone = selectionOptionsClone.filter((item) => item.name !== "Fetch Contacts");
      }
      return selectionOptionsClone;
    }
  }, [userDetails, selectedCompanyArray]);

  return (
    <div className="d-inline-block mt-3">
      <SelectionBarTemplete type={type} options={selectionOptions} clearSelection={clearSelection} selectedCompanyArray={selectedCompanyArray} />
    </div>
  );
};
